import { Link, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from "@/hooks/useAuth";

const AdminProtectedRoute = ({ children }: { children: React.ReactNode }) => {
    const { user, isLoading, isAdmin } = useAuth();
    const location = useLocation();
    const isDev = process.env.NODE_ENV === 'development';

    console.log("--- ADMIN GUARD DEBUG ---");
    console.log("Loading State:", isLoading);
    console.log("Authenticated User:", user?.email);
    console.log("Is Admin:", isAdmin);
    console.log("Pathname:", location.pathname);

    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-[#000814]">
                <div className="text-center">
                    <div className="w-16 h-16 border-4 border-accent/20 border-t-accent rounded-full animate-spin mx-auto mb-4"></div>
                    <p className="text-white font-black uppercase tracking-widest text-[10px]">Checking access...</p>
                    <p className="text-slate-500 text-[8px] mt-2 italic">Please wait...</p>
                </div>
            </div>
        );
    }

    // CASE 1: NOT LOGGED IN -> Redirect to Login
    if (!user) {
        isDev && console.warn("Access Blocked: No active session. Redirecting to terminal login.");
        return <Navigate to="/admin/login" state={{ from: location }} replace />;
    }

    // CASE 2: LOGGED IN BUT NOT ADMIN -> Show Access Denied (Don't redirect to avoid loops)
    if (!isAdmin) {
        isDev && console.warn("Access Blocked: Insufficient clearance levels.", { email: user.email, role: user.role });
        return (
            <div className="flex items-center justify-center min-h-screen bg-[#000814] p-6">
                <div className="card-premium max-w-sm w-full text-center border-red-500/20 bg-red-500/5">
                    <div className="w-16 h-16 rounded-2xl bg-red-500/10 flex items-center justify-center mx-auto mb-6">
                        <div className="text-red-500 font-black text-2xl">!</div>
                    </div>
                    <h3 className="text-white font-black uppercase tracking-tighter text-xl mb-4">Access Denied</h3>
                    <p className="text-slate-400 text-xs font-medium leading-relaxed mb-8">
                        You do not have permission to access the admin area.
                        Please contact the administrator if you believe this is a mistake.
                    </p>
                    <div className="flex flex-col gap-3">
                        <Link to="/" replace className="w-full">
                            <button className="btn-gold w-full h-12 text-[10px] font-black uppercase tracking-widest">
                                Go Back to Home
                            </button>
                        </Link>
                    </div>
                </div>
            </div>
        );
    }

    return <>{children}</>;
};

export default AdminProtectedRoute;
